var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.6667C16 12.0203 15.8563 12.3594 15.6006 12.6095C15.3449 12.8595 14.998 13 14.6364 13H2.36364C2.00198 13 1.65513 12.8595 1.3994 12.6095C1.14367 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14367 3.64057 1.3994 3.39052C1.65513 3.14048 2.00198 3 2.36364 3H5.09091L6.45455 1H10.5455L11.9091 3H14.6364C14.998 3 15.3449 3.14048 15.6006 3.39052C15.8563 3.64057 16 3.97971 16 4.33333V11.6667Z",
    stroke: "#9296AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.3333C10.0062 10.3333 11.2273 9.13943 11.2273 7.66667C11.2273 6.19391 10.0062 5 8.5 5C6.99377 5 5.77273 6.19391 5.77273 7.66667C5.77273 9.13943 6.99377 10.3333 8.5 10.3333Z",
    stroke: "#9296AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamIcon);
export default __webpack_public_path__ + "static/media/camIcon.773563d23a309f217b67c35caf4d08cd.svg";
export { ForwardRef as ReactComponent };